import EmailValidation from '@/forms/FormElements/Rows/EmailRow/EmailRow.validation';
import BaseValidation from '@/forms/Validations/BaseValidation';

export default () => {
  const validations = [EmailValidation('Person', { addBlackListValidation: true })];

  return {
    validations: BaseValidation.getRules(validations),
    messages: BaseValidation.getMessages(validations),
    model: BaseValidation.getModel(validations),
  };
};
